var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_layout"},[_c('OfflineCompanion'),_c('ProfileHeader'),_c('div',{staticClass:"_layout-content"},[_c('GlobalWrapper',[_c('nuxt')],1)],1),_c('TheBottomTabBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }